import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Card, CardBody, Button } from 'reactstrap'
import { getActivityReplyGraphs } from '../../../../../actions/activities_actions'
import { getSurveyWordCloud } from '../../../../../actions/activities_reply_actions';
import Loader from "react-loaders";
import LoadingOverlay from 'react-loading-overlay-ts';
import ReactWordcloud from "react-wordcloud";
import { Resizable } from "re-resizable";


export default function GraphCartsWordCloud(props) {
    const [wordCloud, setWordCloud] = useState([])
    const [isLoading, setLoading] = useState(true)
    const [isShowWordCloud, setShowWordCloud] = useState(false)
const dispatch = useDispatch()
    const options = {
        rotations: 2,
        rotationAngles: [-90, 0],
        fontFamily: 'Poppins',
    fontSizes:[20,60]
        
    };
    const resizeStyle = {
        display: "flex",
        alignItems: "center",
     justifyContent: "center",
        margin: 'auto',
        border: "none",
        background: "#ffffff",

    };
  

    const getSurveyQuestionWordCloud = (questionId, activityId) => {
        
        // setLoading(true)
        // let questionId = []
        // if (isShowQuestion) {
        //     questionId = selectedQuestion.map(question => question.questionId)
        // }
        console.log('activity id ->',props.activityId)
        console.log('question id ->',props.questionId)
        dispatch(getSurveyWordCloud({ questionId: questionId, activityId: activityId }))
            .then((response) => {
                console.log('response of wordcloud->', response.payload.content)
                
                setWordCloud([...response.payload.content.wordCloud])
                setShowWordCloud(true)
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
            })


    }
    useEffect(()=>{
        getSurveyQuestionWordCloud()
    },[])

    return (
        <>
        <div>
            <Button className='btn-primary' onClick={() => getSurveyQuestionWordCloud(props.questionId, props.activityId)}>Generate Wordcloud</Button>

        </div>
                                                    {
        isShowWordCloud && <Resizable
            defaultSize={{
                width: 'auto',
                height: 'auto'
            }}
            style={resizeStyle}
        >
            <div style={{ width: "100%", height: "100%" }}>
                {/* Word cloud */}
                <ReactWordcloud words={wordCloud} options={options}  />
            </div>
        </Resizable>
    }
    </>
    
  )
}
